<template>
	<div>
		<div class="d-flex justify-content-center py-4" v-if="isLoading">
			<loader/>
		</div>
		<notification-message
			message="Parece que aún no agregas etiquetas"
			v-if="tags=='' && !isLoading"
		/>

		<div class="main-content-container container-fluid px-4" v-if="!isLoading">
      <div class="page-header row no-gutters py-4">
        <div class="col-12 col-sm-6 text-center text-sm-left mb-4 mb-sm-0">
          <span class="text-uppercase page-subtitle">Visión general</span>
          <h3 class="page-title">Etiquetas</h3>
        </div>
        <div class="col-12 col-sm-6 d-flex align-items-center">
          <div class="d-none d-md-inline-flex mb-sm-0 mx-auto ml-sm-auto mr-sm-0" role="group" aria-label="Page actions">
            <router-link to="agregar/etiqueta" id="add-new-event" class="btn btn-primary">
              <i class="fas fa-plus"></i> 
              Etiqueta 
            </router-link>
          </div>
        </div>
      </div>

			<div class="row">
				<div v-for="(item, index) of tags" class="col-lg-3 col-md-6 col-sm-12 mb-4">
					<router-link :to="'/etiqueta/' + item.slug" class="no-hover">
						<div class="card card-small card-post card-post--1">
							<div class="card-body text-center">
								<h4 class="font-weight-bold text-uppercase">{{ item.name }}</h4>
							</div>
							<div class="card-footer border-top text-primary">
								<span class="badge badge-secondary mr-2" @click.prevent="deleteOption(item.id, index)">
									<i class="fas fa-trash"/>
								</span>
								<span class="badge badge-secondary"><i class="fas fa-edit"></i></span>
							</div>
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import NotificationMessage from '@/components/general/NotificationMessage.vue';
	import axios from 'axios'
	export default {
		components: {
			NotificationMessage
		},

		data() {
			return {
				isLoading: true,
				tags: []
			}
		},

		methods: {
			getTags() {
				axios.get(`${process.env.VUE_APP_ROOT_API}/tag`)
					.then(response => {
						if(response.status == 200) {
							this.isLoading = false;
							this.tags = response.data;
						}
					})
					.catch(err => {
						console.log(err);
					});
			},

			deleteOption(id, index) {
				const message = '¿Quieres eliminar esta etiqueta?';
				const options = {
					okText: 'Sí',
					cancelText: 'No'
				};
				let that = this;
				this.$dialog
					.confirm(message, options)
					.then(function(dialog) {
						that.deleteTag(id, index);
					});
			},

			async deleteTag(id, index) {
				const url = `${process.env.VUE_APP_ROOT_API}/tag/${id}`;
				const settings = {
					method: 'DELETE'
				};
				const response = await fetch(url, settings);
				switch (response.status) {
					case 200:
						this.tags.splice(index, 1);
						break;
				}
			}
		},

		mounted() {
			this.getTags();
		}
	}
</script>